<template>
    <div class="admin-m">
        <label>{{field.templateOptions.label}}</label>
        <div class="mb-3"><small v-if="field.templateOptions.note">{{field.templateOptions.note}}</small>
        </div>
        <error-display :form="form" :field="field.key"></error-display>
        <vue-mce :config="config" v-model="model[field.key]"/>
    </div>
</template>

<script>
  import baseField from 'vue-formly-bootstrap/src/fields/baseField';
  import { API_ROOT } from '../../constants';

  export default {
    name: 'MceField',
    mixins: [baseField],
    data: () => ({
      config: {
        theme: 'modern',
        plugins:
          "advlist autolink lists link image charmap print code fullscreen table hr textcolor"
        ,
        fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
        language: 'sk',
        image_advtab: true,
        images_upload_url: API_ROOT + '/media/upload',
        relative_urls: false,
        height: 300,
        statusbar: false,
        menubar: false,
        toolbar: 'undo redo' +
          ' | fontselect  fontsizeselect forecolor' +
          ' | bold italic underline strikethrough hr' +
          ' | alignleft  aligncenter alignright alignjustify' +
          ' | bullist numlist blockquote outdent indent table' +
          ' | link image imagetools' +
          ' | removeformat code fullscreen',
      },
    }),
    components: {
      'vue-mce': () => import('vue-mce/src/component/index.vue')
    }
  };
</script>

